
import React, { useEffect, useState } from 'react'
import { Row, Col, Alert, Badge, CloseButton } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import Card from '../../../components/Card'

import { ProductItem } from '../../../features/products';
import { getProducts, getPropertyInfo } from '../../../services/api/product';
import { ApiError, Product } from '../../../services/openapi';

import { useKeycloak } from '@react-keycloak/web'

import SearchInput from '../../../components/SearchInput';
import ListPagination from '../../../components/ListPagination';
import RefreshPull from '../../../components/RefreshPull';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { peekPendingSelectedId, clearPendingSelectedId } from '../../../hooks/pendingSelection';
import { useTranslation } from 'react-i18next';


const Terminals = () => {
    const [products, setProducts] = useState<Product[]>([]);        
    const [productCount, setProductCount] = useState<string>("0");    
    const [pagingString, setPagingString] = useState<string>("0-25");    
    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
    const [tableBodyHeight, setTableBodyHeight] = useState<number>(380);
    const [formData, setFormData] = useLocalStorage<string>("products", "formData", "");
    const [searchData, setSearchData] = useLocalStorage<Record<string, string>>("products", "searchData", {});
    const [filterData, setFilterData] = useLocalStorage<string>("products", "filterData", "");
    const [currentPage, setCurrentPage] = useLocalStorage<number>("products", "currentPage", 0);
    const [siteIdFilter, setIdSiteFilter] = useLocalStorage<number[]>("sites", "siteFilter", []);
    const [siteTypeFilter, setSiteTypeFilter] = useLocalStorage<string[]>("sites", "siteTypeFilter", []);
    const [siteFilterQuery, setSiteFilterQuery] = useLocalStorage<string>("sites", "siteFilterQuery", "");
    const [errorMsg, setErrorMsg] = useState<string[]>([]);
    const [selectedId, setSelectedId] = useState<number | null>(() => peekPendingSelectedId("products"));
    const [rowClickCount, setRowClickCount] = useState({});
    const [newProduct, setNewProduct] = useState<Product>();

    const { keycloak, initialized } = useKeycloak();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const setData = (data: Product) => {
        localStorage.setItem('Product', JSON.stringify(data));
    }

    const delay = async (ms: number) => {
        await new Promise(resolve => setTimeout(resolve, ms));
    }

    let timer: NodeJS.Timeout | null = null;

    const submitSearch = () => {
        formData === "" ? setFormData(" ") : setFormData("");
    }

    const handleChange = () => {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(submitSearch, 2000);
        setCurrentPage(0);
    }

    const handleRowClick = (tx) => {
        if (window.matchMedia('(pointer: coarse)').matches) {
            setRowClickCount({ [tx.id]: 1 });
        }
        
        setRowClickCount((prev) => {
            const newCount = (prev[tx.id] || 0) + 1;
            if (newCount === 1) {
            setSelectedId(tx.id);
            return { ...prev, [tx.id]: newCount };
            } else if (newCount === 2) {
            setData(tx);
            navigate("/dashboard/details/product");
            setSelectedId(tx.id);
            return { ...prev, [tx.id]: 0 };
            }
            return prev;
        });
    };

    const handlePaging = async (e: number) => {
        errorMsg.length = 0;

        do {
            await delay(1000);
        } while (isRefreshing);

        setCurrentPage(e);

        const start = ((e + 1) * 25) - 25;
        const end = ((e + 1) * 25);
        const rangeString = `${start}-${end}`
        setPagingString(rangeString);

        document.querySelector('#refresh')?.classList.remove("d-none")
        setIsRefreshing(true);

        getProducts(keycloak.token || '', rangeString, { search: formData, Online: filterData, sites: siteIdFilter.join(), sitesQuery: siteFilterQuery, languageCode: i18n.language }, searchData)
            .then((result) => {
                setProducts(result.body);
                var totalCount = result.header.split('/')[1];
                setProductCount(totalCount);
                document.querySelector('#refresh')?.classList.add("d-none");
                setIsRefreshing(false);
                let p: Product = {
                    id: 0,
                    name: "",
                    description: "",
                    chargeAmount: 0,
                    pricePerUnit: 0,
                    unit_Charging: "",
                    unit_Controllino: "",
                    limit_Charging: 0,
                    limit_Controllino: 0,
                    note: "",
                    propertyNames: result?.body[0]?.propertyNames
                } as unknown as Product;

                if (!p?.propertyNames) {
                    getPropertyInfo(keycloak.token || '').then((res: any) => {
                            p.propertyNames = res;
                            p.siteId = res?.siteId?.predefinedValues ? res.siteId.predefinedValues[0] : null;
                            setNewProduct(p);
                        }).catch((ex: any) => {
                             setNewProduct(p)
                        })
                    } else {
                        setNewProduct(p);
                    }
            })
            .catch((error: ApiError) => {
                try {
                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                    Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                } catch (ex) {
                    errorMsg.push("Error handling response");
                    setErrorMsg(errorMsg);
                }

                document.querySelector('#refresh')?.classList.add("d-none");
                setIsRefreshing(false);
            });
    }

    const handleFilter = (e: string): void => {
        setProducts([]);
        setFilterData(e);
        setCurrentPage(0);
    }

    const handleSearch = (e: string): void => {
        setProducts([]);
        searchData["search"] = e;
        setSearchData(searchData);
        handleChange();
    }

    const handleSearchColumn1 = (e: string): void => {
        setProducts([]);
        searchData["name"] = e;
        setSearchData(searchData);
        handleChange();
    }

    const handleSearchColumn2 = (e: string): void => {
        setProducts([]);
        searchData["chargeAmount"] = e;
        setSearchData(searchData);
        handleChange();
    }

    const handleSearchColumn3 = (e: string): void => {
        setProducts([]);
        searchData["note"] = e;
        setSearchData(searchData);
        handleChange();
    }

    const handleRefreshButton = (): void => {
        setProducts([]);
        formData === "" ? setFormData(" ") : setFormData("");
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>): boolean => {
        if (event.key === 'Enter') {
            event.preventDefault();
            return false;
        }
        return true;
    }

    const init = () => {
        document.querySelector('.errorMsg')?.classList.add("d-none");
        handlePaging(currentPage ?? 0);
        initSearchFields();
    }; 

    const initSearchFields = () => {
        Object.keys(searchData).map(x => {
            const search: HTMLInputElement | null = document.querySelector(`.${x}`) as HTMLInputElement;
            if (search) {
                search.value = searchData[x];
            }
        })
    }

    const onResize = () => {
        var e = document.querySelector(".vertical-scrollable") as HTMLElement;
        var h = window.innerHeight;
        e.style.height = (h - 284) + "px";
        e.style.maxHeight = (h - 280) + "px";
        setTableBodyHeight(h - 284);        
    };

    useEffect(() => {
        window.addEventListener("resize", onResize);
        onResize();
        if (products?.length === 0) {
            init();
        }
        clearPendingSelectedId("products");
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);

    useEffect(() => {
        if (products.length > 0) return;
        init();
    }, [formData, filterData]);

    //const handleRequestCtmp = useCallback((id: number) => {
    //    requestCtmp(keycloak.token || '', id).catch((err) => setError(err));
    //}, []);

    return (
        <>
            <Row className="">                  
                <Col className="">
                    <Card className="rounded">                        
                        <Card.Body className="">
                            <Row className="d-none d-md-block">
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row className="d-none d-md-block">
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row className="">
                                <Col sm="12" className="">    
                                    <h4 className="mb-2  qvend-title">{t("producten")}</h4>                                    
                                </Col>
                            </Row>                            
                            <Row style={{ fontSize: '11px' }}>
                                <Col md={3} xs={5} style={{ paddingRight: 0 }}>
                                    <div className="bd-example">
                                        <div>
                                            <SearchInput className="form-control search" type="search" placeholder={t("search")} onChange={handleSearch} value={searchData.search ?? ""} />
                                        </div>                                            
                                    </div>                                    
                                </Col>
                                <Col md={3} xs={1}>
                                    <button type="button" className="btn btn-qvend" style={{ fontSize: '11px', padding: '0.5rem 0.3rem' }}>...</button>
                                </Col>                                    
                                <Col className="text-end">
                                    {hasSites(newProduct) && (siteTypeFilter.length == 0 || (siteTypeFilter.length > 0 && !siteTypeFilter.every(x => x === 'Basic'))) ? (<Link to="/dashboard/details/product" className="btn btn-qvend" style={{ fontSize: '11px', padding: '0.5rem 0.5rem', margin: '5px' }} onClick={() => {
                                                                            let siteIdValue: string = "";
                                                                            if (newProduct && newProduct!.propertyNames && newProduct!.propertyNames["siteId"] && newProduct!.propertyNames["siteId"]["predefinedValues"]) {
                                                                                let values = newProduct!.propertyNames["siteId"]["predefinedValues"];
                                                                                if (values.length === 1) {
                                                                                    siteIdValue = values[0];
                                                                                }
                                                                            }
                                                                            newProduct && (newProduct.siteId = siteIdValue ? siteIdValue : (siteIdFilter.length === 1 ? siteIdFilter.pop()!.toString() : "0")); setData(newProduct!);
                                                                        }} key={0}>+</Link>) : (
                                            <a className="btn btn-qvend" style={{ pointerEvents: 'none', color: 'gray', backgroundColor: 'lightgray', cursor: 'default', fontSize: '11px', padding: '0.5rem 0.5rem', margin: '5px' }}
                                            onClick={(e) => e.preventDefault()}
                                        >+</a>
                                        ) }
                                    <button type="button" className="btn btn-qvend" style={{ fontSize: '11px' }}>Download</button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} xs={10} style={{ paddingRight: 0, fontSize: '11px' }} className="form-control-sm">
                                    {((siteIdFilter && siteIdFilter.length > 0) || (siteFilterQuery && siteFilterQuery.length > 2)) ? <span className="text-end">
                                        <Badge pill bg="dark" className="p-1 " onClick={() => { setIdSiteFilter([]); setSiteFilterQuery(""); setSiteTypeFilter([]); setProducts([]); setCurrentPage(0); formData === "" ? setFormData(" ") : setFormData(""); window.localStorage.removeItem("searchDataSites") }}><CloseButton variant="white" /> Sites</Badge></span> : null}
                                </Col>
                            </Row>
                            <Row className="">
                                <Col sm="12" xs="12" className="mt-2">
                                    <RefreshPull isRefreshing={isRefreshing} onSetPage={handlePaging} />
                                    <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                        <div>
                                            <Row className="qvend-table-font" style={{ background: "#2b2e83", color: "#FFFFFF", overflowY: "scroll"  }}>
                                                <Col md={4} xs={6} className="qvend-table table-column-first">{t('product.product')}</Col>
                                                <Col md={4} xs={3} className="qvend-table">{t('product.price')}</Col>
                                                <Col md={4} xs={3} className="qvend-table">{t('product.note')}</Col>
                                            </Row>
                                        </div>
                                        <div className="vertical-scrollable" style={{ overscrollBehaviorY: 'contain' }}>
                                            <Row className={("qvend-table-font")} style={{ background: "#cfd5ea", color: "black" }}>
                                                <Col md={4} xs={6} className="qvend-table search-in-row-first"><SearchInput className="form-control name" type="search" onChange={handleSearchColumn1} value={searchData.name ?? ""} /></Col>
                                                <Col md={4} xs={3} className="qvend-table search-in-row-padding"><SearchInput className="form-control chargeAmount" type="search" onChange={handleSearchColumn2} value={searchData.chargeAmount ?? ""} /></Col>
                                                <Col md={4} xs={3} className="qvend-table search-in-row-padding"><SearchInput className="form-control note" type="search" onChange={handleSearchColumn3} value={searchData.note ?? ""} /></Col>
                                            </Row>
                                            <Row className="d-none errorMsg">
                                                <Col>
                                                    {
                                                        errorMsg.map((item, index) => {
                                                            return <Alert key={index} variant="warning" className="alert" role="alert">
                                                                <span>{item}</span>
                                                            </Alert>;
                                                        })
                                                    }
                                                </Col>
                                            </Row>
                                            {products.map((prod: Product, index) => (
                                                <Link to="#" onClick={() => handleRowClick(prod)} key={prod.id}>
                                                    <ProductItem
                                                        key={prod.id}
                                                        product={prod}                                                     
                                                        rowColor={selectedId === prod.id ? "gray" :index % 2 ? "#cfd5ea" : "#e9ebf5"}
                                                    />
                                                </Link>
                                            ))}
                                            {                                                
                                                //Array.from({ ...dummyTerminal, length: (tableBodyHeight / 16.5) - terminals.length } as unknown as Terminal[]).map((terminal: Terminal, index) => (
                                                //    <TerminalItem
                                                //        key={index + terminals.length}
                                                //        terminal={dummyTerminal}
                                                //        rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"}
                                                //    />
                                                //))
                                            }
                                        </div>
                                    </div>
                                </Col>                              
                            </Row>
                            <ListPagination
                                articlesCount={productCount}
                                currentPage={currentPage}
                                onSetPage={handlePaging}
                                onRefresh={handleRefreshButton} />
                        </Card.Body>
                    </Card>
                </Col>                                    
            </Row>
        </>
    )
}

export default Terminals

function hasRole(product: any, key: string, keycloak: any) {
    if (!(product && product.propertyNames && product.propertyNames[key])) {
        return false;
    }

    const prop = product.propertyNames[key];
    const roleNames = prop ? prop.roleNames : null;
    if (roleNames === null || roleNames === undefined) return true;
    let result: boolean = false;
    if (!keycloak) return false;
    roleNames.forEach((role: string) => { result = result || keycloak.hasResourceRole(role); });
    return result;
}

function hasSites(product: any) {
    if (!(product && product.propertyNames && product.propertyNames["siteId"] && product.propertyNames["siteId"]["predefinedValues"])) {
        return false;
    }

    const vals = product.propertyNames["siteId"]["predefinedValues"];
    if (!Array.isArray(vals)) return false;
    if (vals.length === 0) return false;
    return true;
}
